import { render, staticRenderFns } from "./StartWithCode.vue?vue&type=template&id=0338981d&lang=pug&"
import script from "./StartWithCode.vue?vue&type=script&lang=ts&"
export * from "./StartWithCode.vue?vue&type=script&lang=ts&"
import style0 from "./StartWithCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports